import { render, staticRenderFns } from "./bumenDetails.vue?vue&type=template&id=43b6f23e&scoped=true&"
import script from "./bumenDetails.vue?vue&type=script&lang=js&"
export * from "./bumenDetails.vue?vue&type=script&lang=js&"
import style0 from "./bumenDetails.vue?vue&type=style&index=0&id=43b6f23e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b6f23e",
  null
  
)

export default component.exports